import { render, staticRenderFns } from "./UserAppChatNotificactionDropdown.vue?vue&type=template&id=ed2f37bc"
import script from "./UserAppChatNotificactionDropdown.vue?vue&type=script&lang=js"
export * from "./UserAppChatNotificactionDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports